import { ILocation } from '@websites/model';

export const atLeastOneLocationHasMap = (locations: ILocation[]) => {
  const locsWithMap = locations.find((loc) => loc.hasMap);
  return !!locsWithMap;
};
